import React, { forwardRef, useEffect, useState, useContext } from "react";
// import { Dropdown } from "../view/Dropdown";
import { downloadFile, getAvailableDates, getLogs, saveDebugMode, getDebugMode } from "./logService";
// import { Spinner } from "../view/Spinner";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { PopupContext } from "../index";
import { getConfirmPopup } from "../view/popup/PopupContainer";
import ChooseDeviceField from "./ChooseDeviceField";
import * as deviceService from "../devices/deviceService";
import SearchInputV2 from "../view/SearchInputV2";
import { RefreshCw, Download, Bug, ChevronDown } from "lucide-react";
import Select from "react-select";

const LOGS = [
    { id: 0, name: 'Application', value: 'APP' },
    { id: 1, name: 'Syslog', value: 'SYSLOG' },

]

const LineOptions = [
    { id: 0, name: '50', value: 50 },
    { id: 1, name: '250', value: 250 },
    { id: 2, name: '500', value: 500 },
]

function LogsSection() {

    const initialState = {
        selectedDevice: null,
        selectIp: null
    }

    const [state, setState] = useState(initialState);

    const [logSource, setLogSource] = useState(LOGS[0]);
    const [logText, setLogText] = useState('');
    const [showLines, setShowLines] = useState(LineOptions[0]);
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [availableDates, setAvailableDates] = useState({ app: [new Date()], syslog: [new Date()] })
    const [lastUpdated, setLastUpdated] = useState(Date.now());
    const [loading, setLoading] = useState(false);

    //Added by Octopus DevTeam November 23,2022
    const [debugMode, setDebugMode] = useState(0);
    const { setPopup } = useContext(PopupContext);
    const [devices, setDevices] = useState([]);
    const [keyword, setKeyword] = useState('');
    const [collapsed, setCollapsed] = useState(false);

    const fetchDataDevice = async () => {
        try {
            const deviceList = await deviceService.list();
            const syslogEnabledDevices = deviceList.filter(
                device => device.enableSyslogProcessing === true
            );
            setDevices(syslogEnabledDevices);
        } catch (error) {
            console.error('Error:', error);
        }
    };

    useEffect(() => {
        fetchDataDevice();
    }, []);

    const fetchData = async () => {
        try {
            setLoading(true);
            const logs = await getLogs(logSource.value, showLines.value, selectedDate, state.selectedIp, keyword);
            const dates = await getAvailableDates();
            const debugModeValue = await getDebugMode();

            setAvailableDates(dates);
            setLogText(logs.data ? logs.data.trimEnd().split('\n').reverse().join('\n') : '');
            setLoading(false);

            setDebugMode(parseInt(debugModeValue.value));
        } catch (error) {
            console.error('Error:', error);
        }
    };

    useEffect(() => {
        fetchData();
        /* eslint-disable react-hooks/exhaustive-deps */
    }, [logSource, showLines, lastUpdated, selectedDate, state.selectedDevice, keyword]);

    const onLogSourceChange = (id) => {
        setSelectedDate(new Date());
        setLogSource(LOGS.find(l => l.id === Number(id)))
    }

    const getDatepickerDates = () => {
        return logSource.name === 'Syslog' ? availableDates.syslog : availableDates.app
    }


    const onDownloadClick = () => {
        let connectionType = '';
        let deviceIp = '';
        if (state.selectedDevice) {
            connectionType = state.selectedDevice.connectionType;
        }
        if (state.selectedIp) {
            deviceIp = state.selectedIp;
        }
        downloadFile(selectedDate, logSource.value, deviceIp, connectionType);
    }

    const DatePickerInput = forwardRef(({ value, onClick }, ref) => (
        <button type="button" className="btn oct_btn-datefrom-v2 oct_datepicker-fullwidth" onClick={onClick} ref={ref}>
            {value || 'Select a date'}
        </button>
    ));

    //Added by Octopus DevTeam November 23,2022
    const onDebugModeClick = async () => {
        //get the debug mode from database:

        if (debugMode === 0) {
            const newdebugMode = 1;
            setDebugMode(newdebugMode);
            await saveDebugMode(newdebugMode);
        }
        if (debugMode === 1) {
            const newdebugMode = 0;
            setDebugMode(newdebugMode);//change the text on the button directly
            await saveDebugMode(newdebugMode);
        }
    }

    //Added by Octopus DevTeam December 22,2022
    const onConfirm = () => {
        onDebugModeClick();
    }

    const onDeviceChange = (value) => {
        let ip;
        if (value) {
            ip = value.mngtIpAddress;
        }
        setState({
            ...state,
            selectedDevice: value,
            selectedIp: ip
        });
    }

    const onKewordSearch = (value) => {
        setKeyword(value);
        // const caseInsensitiveValue = value ? value.toLowerCase() : value; // Convert to lowercase if value is not empty
        // history.push({
        //     pathname: history.pathname,
        //     search: caseInsensitiveValue ? urlService.updateFilters('name', caseInsensitiveValue) : urlService.removeFilter('name')
        // });
    };

    // const onKeywordResetClick = () => {
    //     history.push('/logs');
    // }

    const logSourceOptions = LOGS.map(log => ({ value: log.id, label: log.name }));
    const showLinesOptions = LineOptions.map(line => ({ value: line.id, label: line.name }));

    return (
        <div className="container-fluid mt-2">
            <div className="oct_analysis-card-v2 p-4">
                <button
                    className="oct_settings-section-header"
                    onClick={() => setCollapsed(!collapsed)}
                >
                    <h3>Logs Viewer</h3>
                    <ChevronDown
                        className={`oct_icon oct_settings-chevron-v2 ${!collapsed ? 'oct_expanded' : ''}`}
                    />
                </button>

                <div className={`oct_settings-section-body ${collapsed ? 'oct_collapsed' : 'oct_expanded'}`}>
                    {/* Filter Controls */}
                    <div className="oct_filter-section-v2 mt-4">
                        <div className="row align-items-end mb-3">
                            {/* FROM Dropdown */}
                            <div className="col">
                                <label className="oct_filter-label">FROM</label>
                                <Select
                                    className="oct_selectsearch-v2"
                                    classNamePrefix="oct-selectsearchsub-v2"
                                    value={logSourceOptions.find(opt => opt.value === logSource.id) || logSourceOptions[0]}
                                    onChange={(option) => onLogSourceChange(option.value)}
                                    options={logSourceOptions}
                                    isSearchable={false}
                                    menuPortalTarget={document.body}
                                    menuPosition="fixed"
                                />
                            </div>

                            {/* LINES Dropdown */}
                            <div className="col-2">
                                <label className="oct_filter-label">LINES</label>
                                <Select
                                    className="oct_selectsearch-v2"
                                    classNamePrefix="oct-selectsearchsub-v2"
                                    value={showLinesOptions.find(opt => opt.value === showLines.id) || showLinesOptions[0]}
                                    onChange={(option) => setShowLines(LineOptions.find(l => l.id === Number(option.value)))}
                                    options={showLinesOptions}
                                    isSearchable={false}
                                    menuPortalTarget={document.body}
                                    menuPosition="fixed"
                                />
                            </div>

                            {/* Date Input */}
                            <div className="col">
                                <label className="oct_filter-label">DATE</label>
                                <DatePicker
                                    selected={selectedDate}
                                    onChange={(date) => setSelectedDate(date)}
                                    includeDates={getDatepickerDates()}
                                    customInput={<DatePickerInput />}
                                    placeholderText="Select a date"
                                    popperProps={{ strategy: "fixed" }}
                                />
                            </div>

                            {/* Conditional Device Dropdown */}
                            {logSource.id === 1 && (
                                <div className="col">
                                    <label className="oct_filter-label">DEVICE</label>
                                    <ChooseDeviceField
                                        devices={devices}
                                        value={state.selectedDevice}
                                        onChange={onDeviceChange}
                                    />
                                </div>
                            )}

                            {/* REFRESH Button */}
                            <div className="col-auto">
                                <button
                                    type="button"
                                    onClick={() => setLastUpdated(Date.now())}
                                    className="oct_btn-export-v2"
                                    disabled={loading}
                                >
                                    <RefreshCw className={`w-4 h-4 mr-2 ${loading ? 'oct_anim-spin' : ''}`} />
                                    REFRESH
                                </button>
                            </div>

                            {/* DOWNLOAD Button */}
                            <div className="col-auto">
                                <button
                                    type="button"
                                    onClick={onDownloadClick}
                                    className="oct_btn-export-v2"
                                >
                                    <Download className="w-4 h-4 mr-2" />
                                    DOWNLOAD
                                </button>
                            </div>

                            {/* ENABLE/DISABLE DEBUG Button */}
                            <div className="col-auto">
                                {debugMode === 0 ? (
                                    <button
                                        type="button"
                                        className="oct_btn-export-v2"
                                        onClick={() => {
                                            setPopup(
                                                getConfirmPopup('Warning: Enabling debug may have performance impact. It is recommended to enable for troubleshooting purposes. Confirm to proceed.',
                                                    'Enable Debug Mode',
                                                    () => onConfirm()
                                                )
                                            );
                                        }}
                                    >
                                        <Bug className="w-4 h-4 mr-2" />
                                        ENABLE DEBUG
                                    </button>
                                ) : (
                                    <button
                                        type="button"
                                        className="oct_btn-warning-v2"
                                        onClick={onDebugModeClick}
                                    >
                                        <Bug className="w-4 h-4 mr-2" />
                                        DISABLE DEBUG
                                    </button>
                                )}
                            </div>
                        </div>

                        {/* KEYWORD Search (Second Row) */}
                        <div className="row">
                            <div className="col">
                                <SearchInputV2
                                    value={keyword || ''}
                                    onChange={(e) => onKewordSearch(e.target.value)}
                                    placeholder="Search logs KEYWORDS..."
                                    className="m-0"
                                />
                            </div>
                        </div>
                    </div>

                    {/* Log Viewer */}
                    <div className="oct_logs-viewer-wrapper-v2 mt-4">
                        <pre>
                            {logText}
                        </pre>
                    </div>
                </div>
            </div>
        </div>
    )

}

export default LogsSection
